import React, { useState, useEffect, Fragment, } from 'react';
import dotenv from 'dotenv';

import SewWidget, { SewWidgetProps, } from './SewWidget';
import getReviewRatingAwardData from '../helpers/apiHelper';
import { InitialData, } from '../../sew-core/store';

declare global {
  interface Window {
    editorialWidget: any;
  }
}

const getQueryParamsFromUrl = (): Record<string, string> => {
  if (typeof window === 'undefined' || !window.location.search) {
    return {};
  }
  try {
    const pairs = window.location.search.slice(1).split('&');
    const queryObject = pairs
      .filter((pair) => pair.indexOf('=') > 0)
      .reduce((acc: any, pair) => {
        let [key, value] = pair.split('=');
        key = key.toLowerCase();
        if (key !== 'apikey') {
          value = value.toLowerCase();
        }
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});
    return queryObject;
  } catch (e) {
    return {};
  }
};

const shouldRenderWidget = (params: {} | null): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (params) {
    return false;
  }
  return true;
};

const queryParams: Record<string, string> = getQueryParamsFromUrl();

const SewWidgetWrapper = ({ initialData, }: SewWidgetProps<Record<string, any>>) => {
  // set env vars
  dotenv.config();

  const combinedInitialData: InitialData = {
    config: {
      ...initialData.config,
      queryParams,
    },
    theme: initialData.theme,
  };

  const [state, setState] = useState({
    initialData: combinedInitialData,
    shouldRenderWidget: shouldRenderWidget(queryParams),
    initialRender: true,
  });
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.editorialWidget = combinedInitialData;
    }
    getReviewRatingAwardData(queryParams)
      .then((data) => {
        if (data) {
          const updatedInitialData: InitialData = {
            config: combinedInitialData.config,
            theme: combinedInitialData.theme,
            rraData: data,
          };
          setState({
            initialData: updatedInitialData,
            shouldRenderWidget: true,
            initialRender: false,
          });
        } else {
          const updatedInitialData: InitialData = {
            config: combinedInitialData.config,
            theme: combinedInitialData.theme,
          };
          setState({
            initialData: updatedInitialData,
            shouldRenderWidget: true,
            initialRender: false,
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  return (
    <Fragment>
      <SewWidget initialData={state.initialData} initialRender={state.initialRender} />
    </Fragment>
  );
};

export default SewWidgetWrapper;
